import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.48 0) scale(0.96)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4 6.5C4 5.96957 4.21071 5.46086 4.58579 5.08579C4.96086 4.71071 5.46957 4.5 6 4.5H8C8.53043 4.5 9.03914 4.71071 9.41421 5.08579C9.78929 5.46086 10 5.96957 10 6.5V8.5C10 9.03043 9.78929 9.53914 9.41421 9.91421C9.03914 10.2893 8.53043 10.5 8 10.5H6C5.46957 10.5 4.96086 10.2893 4.58579 9.91421C4.21071 9.53914 4 9.03043 4 8.5V6.5Z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14 6.5C14 5.96957 14.2107 5.46086 14.5858 5.08579C14.9609 4.71071 15.4696 4.5 16 4.5H18C18.5304 4.5 19.0391 4.71071 19.4142 5.08579C19.7893 5.46086 20 5.96957 20 6.5V8.5C20 9.03043 19.7893 9.53914 19.4142 9.91421C19.0391 10.2893 18.5304 10.5 18 10.5H16C15.4696 10.5 14.9609 10.2893 14.5858 9.91421C14.2107 9.53914 14 9.03043 14 8.5V6.5Z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 16.5C4 15.9696 4.21071 15.4609 4.58579 15.0858C4.96086 14.7107 5.46957 14.5 6 14.5H8C8.53043 14.5 9.03914 14.7107 9.41421 15.0858C9.78929 15.4609 10 15.9696 10 16.5V18.5C10 19.0304 9.78929 19.5391 9.41421 19.9142C9.03914 20.2893 8.53043 20.5 8 20.5H6C5.46957 20.5 4.96086 20.2893 4.58579 19.9142C4.21071 19.5391 4 19.0304 4 18.5V16.5Z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14 16.5C14 15.9696 14.2107 15.4609 14.5858 15.0858C14.9609 14.7107 15.4696 14.5 16 14.5H18C18.5304 14.5 19.0391 14.7107 19.4142 15.0858C19.7893 15.4609 20 15.9696 20 16.5V18.5C20 19.0304 19.7893 19.5391 19.4142 19.9142C19.0391 20.2893 18.5304 20.5 18 20.5H16C15.4696 20.5 14.9609 20.2893 14.5858 19.9142C14.2107 19.5391 14 19.0304 14 18.5V16.5Z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgDashboard);
export default ForwardRef;
